import { useTranslation } from 'react-i18next'
import React from 'react'

import ColorPicker from '../../../../packages/kiti/components/form/ColorPicker'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import IconPicker from '../../../../components/form/IconPicker'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const GeneralSection = () => {
  const { t } = useTranslation('projects')

  return (
    <>
      <FormItem label={`${t('project.form.field.name')}*`} field="name" />
      <Separator weight={4} />
      <FormItem label={`${t('project.form.field.icon')}*`} field="icon" Input={IconPicker} />
      <Separator weight={4} />
      <FormItem label={`${t('project.form.field.color')}*`} field="color" Input={ColorPicker} />
    </>
  )
}

export default GeneralSection
